// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1156":"271ec6fa001767850605","4763":"748fb160f50e7883588e"}[chunkId] + ".chunk.js";
};